import { render, staticRenderFns } from "./PrivacyDialog.vue?vue&type=template&id=4ad6e432&scoped=true&"
import script from "./PrivacyDialog.vue?vue&type=script&lang=ts&"
export * from "./PrivacyDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PrivacyAndOffer.style.scss?vue&type=style&index=0&id=4ad6e432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad6e432",
  null
  
)

export default component.exports